<template>
  <div class="dashboard">
    <Header />
    <CalendarButtonSection />
    <ServiceAvailableAlertSection />
    <LatestNews />
    <LatestSchedules />
    <Footer />
    <b-modal
      v-model="computedShowConfirmTutorialModal"
      :on-cancel="cancelConfirmTutorialModal"
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-label="PurchasePlanModal"
      aria-modal
      :can-cancel="['escape', 'outside']"
    >
      <template #default="props">
        <ConfirmTutorialModal @start-tutorial="startTutorial" @close="props.close" />
      </template>
    </b-modal>
    <b-modal
      v-model="computedShowStartCreateCalendarTutorialModal"
      :on-cancel="cancelConfirmTutorialModal"
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-label="PurchasePlanModal"
      aria-modal
      :can-cancel="['escape', 'outside']"
    >
      <template #default="props">
        <StartCreateCalendarTutorialModal @start-tutorial="goToNext" @close="props.close" />
      </template>
    </b-modal>
    <b-modal
      v-model="computedShowStartInitialSettingTutorialModal"
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-label="StartInitialSettingTutorialModal"
      aria-modal
      :can-cancel="['escape', 'outside']"
    >
      <template #default="props">
        <StartInitialSettingTutorialModal @start-tutorial="goToNext" @close="props.close" />
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import { computed, defineComponent } from "@vue/composition-api";
import { useTutorialStore } from '@/stores/tutorial'
import { useSaveTutorialStatusMutation } from "./tutorial/graphql/mutation/saveTutorialStatus.generated.ts";

import Header from "@/components/Header.vue";
import CalendarButtonSection from "@/components/dashboard/calendarButtonSection.vue";
import ServiceAvailableAlertSection from "@/components/dashboard/ServiceAvailableAlertSection.vue";
import LatestNews from "@/components/dashboard/LatestNews.vue";
import LatestSchedules from "@/components/dashboard/LatestSchedules.vue";
import Footer from "@/components/Footer.vue";
import ConfirmTutorialModal from "@/components/dashboard/ConfirmTutorialModal.vue";
import StartCreateCalendarTutorialModal from "@/components/dashboard/StartCreateCalendarTutorialModal.vue";
import StartInitialSettingTutorialModal from "@/components/tutorial/dashboard/StartInitialSettingTutorialModal.vue";

export default defineComponent({
  name: "Top",
  components: {
    Header,
    Footer,
    CalendarButtonSection,
    ServiceAvailableAlertSection,
    LatestNews,
    LatestSchedules,
    ConfirmTutorialModal,
    StartCreateCalendarTutorialModal,
    StartInitialSettingTutorialModal,
  },
  setup(_, { root }) {
    // const state = reactive({
    //   showConfirmTutorialModal: false,
    //   showStartCreateCalendarTutorialModal: false,
    // })
    const tutorial = useTutorialStore()
    const { mutate: saveTutorialStatusMutate } = useSaveTutorialStatusMutation()
    // onMounted(() => {
    //   state.showConfirmTutorialModal = tutorial.current === 'startTutorial'
    // })
    // const showConfirmTutorialModal = computed(() => tutorial.current === 'startTutorial')
    // const showStartCreateCalendarTutorialModal = computed(() => tutorial.current === 'CREATE_CALENDAR' && tutorial.step === 0)
    const cancelConfirmTutorialModal = () => {
      console.log('cancelConfirmTutorialModal CLICKED!!')
    }
    const computedShowConfirmTutorialModal = computed({
      get: () => tutorial.current === 'BEFORE_START_TUTORIAL',
      set: async () => {
        // チュートリアルスキップの場合のみ呼び出される
        tutorial.skipTutorial()
        await tutorial.changeTutorial('COMPLETED', saveTutorialStatusMutate)
      }
    })
    // const computedShowStartCreateCalendarTutorialModal = computed(() => tutorial.current === 'CREATE_CALENDAR' && tutorial.step === 0)
    const computedShowStartCreateCalendarTutorialModal = computed({
      get: () => tutorial.current === 'CREATE_CALENDAR' && tutorial.step === 0,
      set: async (val) => {
        console.log('computedShowStartCreateCalendarTutorialModal', val)
        tutorial.skipTutorial()
        await tutorial.changeTutorial('COMPLETED', saveTutorialStatusMutate)
        root.$router.push('/')
      }
    })
    const computedShowStartInitialSettingTutorialModal = computed({
      get: () => tutorial.current === 'INITIAL_SETTING' && tutorial.step === 0,
      set: async (val) => {
        console.log('computedShowStartInitialSettingTutorialModal', val)
        tutorial.skipTutorial()
        await tutorial.changeTutorial('COMPLETED', saveTutorialStatusMutate)
        root.$router.push('/')
      }
    })
    const cancelStartCreateCalendarTutorialModal = () => {
      console.log('cancelStartCreateCalendarTutorialModal CLICKED!!')
    }
    const startTutorial = () => {
      console.log('START TUTORIAL')
      tutorial.startTutorial()
      root.$router.push('/tutorial');
    }
    const goToNext = () => {
      console.log('START TUTORIAL')
      tutorial.goToNext()
    }

    return {
      computedShowConfirmTutorialModal,
      computedShowStartCreateCalendarTutorialModal,
      computedShowStartInitialSettingTutorialModal,
      cancelConfirmTutorialModal,
      cancelStartCreateCalendarTutorialModal,
      startTutorial,
      goToNext,
    }
  },
});
</script>

<style lang="scss" scoped>
.dashboard {
  padding-bottom: 56px;
}
::v-deep .modal .animation-content.modal-content .modal-card {
  margin: 0 auto;
}
</style>
